// Loading Skeleton Components untuk berbagai use case

export const ProfileSkeleton = () => (
  <div className="flex items-center gap-3 px-3 py-2 animate-pulse">
    <div className="w-10 h-10 rounded-full bg-gray-300"></div>
    <div>
      <div className="w-24 h-3 bg-gray-300 rounded mb-2"></div>
      <div className="w-16 h-2 bg-gray-200 rounded"></div>
    </div>
  </div>
);

export const CardSkeleton = () => (
  <div className="bg-white rounded-xl shadow p-6 animate-pulse">
    <div className="w-full h-40 bg-gray-300 rounded mb-4"></div>
    <div className="w-3/4 h-4 bg-gray-300 rounded mb-2"></div>
    <div className="w-full h-3 bg-gray-200 rounded mb-2"></div>
    <div className="w-2/3 h-3 bg-gray-200 rounded"></div>
  </div>
);

export const TableSkeleton = ({ rows = 5, cols = 7 }) => (
  <div className="animate-pulse">
    <div className="bg-gray-200 h-10 rounded mb-2"></div>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="bg-gray-100 h-12 rounded mb-1 flex gap-2 p-2">
        {Array.from({ length: cols }).map((_, j) => (
          <div key={j} className="flex-1 bg-gray-300 h-8 rounded"></div>
        ))}
      </div>
    ))}
  </div>
);

export const ListSkeleton = ({ items = 5 }) => (
  <div className="space-y-3 animate-pulse">
    {Array.from({ length: items }).map((_, i) => (
      <div key={i} className="flex items-center gap-3 p-4 bg-gray-100 rounded">
        <div className="w-12 h-12 bg-gray-300 rounded"></div>
        <div className="flex-1">
          <div className="w-3/4 h-4 bg-gray-300 rounded mb-2"></div>
          <div className="w-1/2 h-3 bg-gray-200 rounded"></div>
        </div>
      </div>
    ))}
  </div>
);

export const StatsCardSkeleton = () => (
  <div className="bg-white shadow rounded p-6 animate-pulse">
    <div className="w-1/2 h-3 bg-gray-300 rounded mb-3"></div>
    <div className="w-1/3 h-8 bg-gray-400 rounded"></div>
  </div>
);
